import { render, staticRenderFns } from "./MemoryUseAmountChart.vue?vue&type=template&id=177f633d&"
import script from "./MemoryUseAmountChart.vue?vue&type=script&lang=js&"
export * from "./MemoryUseAmountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports